import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../actions'
import NavBar from './NavBar'
import CreateGame from './games/CreateGame'
import Games from './games/Games'
import Game from './games/Game'
import Users from './users/Users'
import Orders from './orders/Orders'
import Settings from './settings/Settings'
import Dashboard from './dashboard/Dashboard'
import Emails from './emails/Emails'
import Suppliers from './suppliers/Suppliers'
import { ENABLE_2FA } from '../../utilities/enable2fa'
import { isAdmin } from '../../utilities/isAdmin'

const Home = (props) => {
    const [activeItem, setActiveItem] = useState('dashboard')
    const [game, setGame] = useState({})
    const user = useSelector((state) => state.userAdmin)
    const loginTrigger = useSelector((state) => state.auth.loginTrigger)
    const dispatch = useDispatch()
    const { isMobile } = props

    useEffect(() => {
        dispatch(actions.getCurrentUserAdmin())
    }, [dispatch, loginTrigger])

    if (ENABLE_2FA) if (window.localStorage.getItem('verified2FA') !== 'yup') return
    if (user === undefined || user == null) return
    if (user.name === undefined || user.name == null) return
    if (!isAdmin(user)) return

    const renderContent = () => {
        switch (activeItem) {
            case 'dashboard':
                return <Dashboard />
            case 'emails':
                return <Emails />
            case 'games':
                return <Games onChangeItem={handleChangeItemGame} />
            case 'new-game':
                return <CreateGame goBack={handleBackClickedGames} />
            case 'edit-game':
                return <Game game={game} goBack={handleBackClickedGames} />
            case 'orders':
                return <Orders />
            case 'users':
                return <Users/>
            case 'suppliers':
                return <Suppliers/>
            case 'settings':
                return <Settings />
            default:
                return
        }
    }

    const handleChangeItemNavBar = (item) => {
        setActiveItem(item)
    }

    const handleChangeItemGame = (item, game) => {
        if (game && item === 'edit-game') setGame(game)
        setActiveItem(item)
    }

    const handleBackClickedGames = () => {
        setActiveItem('games')
    }

    return (
        <div style={{ paddingBottom: 30, background: '#1b1c1d', minHeight: '100vh', color: 'white' }}>
            <NavBar activeItem={activeItem} onChangeItem={handleChangeItemNavBar} isMobile={isMobile}/>
            {renderContent()}
        </div>
    )
}

export default Home